import { lazy } from 'react'

const fallback = null

const features = Object.freeze({
    HeaderFeature: 
        process.env.RAZZLE_HEADER_COMPONENT
        ? lazy(() => import(`../../components/Header/${process.env.RAZZLE_HEADER_COMPONENT}`))
        : lazy(() => import('../../components/Header/DefaultHeader'))
})

export default features
